module.exports = "/assets/data/4be40352539f8a5aa1bd73dd90914ce3-SA7.data.json";